import React from 'react';


const Slide1 = () => {
  return (
    <div>
      <p>
        このゲームはマスを進めながら単語をゲットし、英文を完成させるゲームです。<br></br>
        このゲームではアイテムを活用し、トラップを避けながら単語を集めます。<br></br>
        色々なアイテムがあり、自分だけの組み合わせを考えてアイテムを装備します。
      </p>
    </div>
  )
}

export default Slide1
